<template>
  <div class="saltopagina">
    <q-card class="marginTag">
      <q-card-section>
        <div class="titleCard">Datos intermedios</div>
        <!--datos de partida y objetivo-->
        <div class="row">
          <div class="col-md-3 col-xs-12 divInputTable">
            <InputTable
              v-if="!isCiudadano"
              type="partida"
              :isManual ="rowPartida.fecha != null"
              :col="colPartida"
              :row="rowPartida"
              :rowObjetivoPartida="rowPartida"
              @updateDatosPartidaYObjetivo="fillDatosPartida" />
              <InputTableNoEditable v-if="rowPartida && isCiudadano" type="partida" :col="colPartida" :row="rowPartida" :rowObjetivoPartida="rowObjetivo" />
          </div>
          <div class="col-md-3 col-xs-12 divInputTable">
            <InputTable
              v-if="!isCiudadano"
              type="objetivo"
              :isManual ="rowObjetivo.fecha != null"
              :col="colObjetivo"
              :row="rowObjetivo"
              :rowObjetivoPartida="rowObjetivo"
              @updateDatosPartidaYObjetivo="fillDatosObjetivo" />
              <InputTableNoEditable v-if="rowObjetivo && isCiudadano" type="objetivo" :col="colObjetivo" :row="rowObjetivo" :rowObjetivoPartida="rowPartida"/>
          </div>
          <div class="col-md-6 col-xs-12">
            <div class="divDatos">
              <div class="divLabel">Periodicidad de la medida: <span style="font-weight: bold;">{{optionPeriodicidadSelected}}</span></div>
            </div>
            <div class="divDatos">
              <div class="divLabel">Unidad de medida: {{unidadMedida}}</div>
            </div>
            <div class="divDatos">
              <div class="divLabel">Fuente del dato: {{fuenteDatoPartida}}</div>
            </div>
          </div>
        </div>
        <!--listado de datos intermedios-->
        <ListadoDatosIntermedios
          :datosIntermedios="datosIntermedios"
          :datosPartidaObjetivo="{
            datoPartida,
            datoObjetivo,
            fechaDatoObjetivo,
            fechaDatoPartida,
          }"
          :idIndicadorCiudad="idCiudadIndicadorAUE"/>
        </q-card-section>
    </q-card>
  </div>
</template>
<script>
import InputTable from '@/components/PlanAccion/components/InputTable.vue';
import ListadoDatosIntermedios from '../components/ListadoDatosIntermedios.vue';
import InputTableNoEditable from '@/components/PlanAccion/components/InputTableNoEditable.vue';
import Vue from 'vue';
import moment from 'moment';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
export default {
  components: {
    InputTableNoEditable,
    ListadoDatosIntermedios,
    InputTable
  },
  props: {
    dataIndicador: Object,
    idCiudadIndicadorAUE: String
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isCiudadano: 'NGUD/isCiudadano'
    })
  },
  data () {
    return {
      observaciones: '',
      fuenteDatoPartida: '',
      indicadoresAsociados: '',
      unidadMedida: '',
      optionsPeriodicidad: [],
      optionPeriodicidadSelected: [],
      colPartida: 'Dato de Partida',
      colObjetivo: 'Dato objetivo',
      rowPartida: { dato: '', fecha: null },
      rowObjetivo: { dato: '', fecha: null, fechaMinima: null },
      datosIntermedios: []
    };
  },
  created () {
    Vue.set(this.rowObjetivo, 'fecha', null);
    Vue.set(this.rowPartida, 'fecha', null);
    Vue.set(this.rowObjetivo, 'fechaMinima', null);
    this.fillData();
  },
  methods: {
    fillData () {
      if (this.dataIndicador.datosPartidaYObjetivo) {
        this.optionPeriodicidadSelected = this.dataIndicador.datosPartidaYObjetivo.periodicidad;
        this.unidadMedida = this.dataIndicador.datosPartidaYObjetivo.unidadMedida;
        this.datoObjetivo = this.dataIndicador.datosPartidaYObjetivo.datoObjetivo;
        this.fechaDatoObjetivo = this.dataIndicador.datosPartidaYObjetivo.fechaDatoObjetivo;
        this.datoPartida = this.dataIndicador.datosPartidaYObjetivo.datoPartida;
        this.fechaDatoPartida = this.dataIndicador.datosPartidaYObjetivo.fechaDatoPartida;
        this.fuenteDatoPartida = this.dataIndicador.datosPartidaYObjetivo.fuenteDatoPartida;
        this.formatDatosIntermedios();
        Vue.set(this.rowObjetivo, 'fecha', null);
        Vue.set(this.rowPartida, 'fecha', null);
        Vue.set(this.rowObjetivo, 'dato', this.dataIndicador.datosPartidaYObjetivo.datoObjetivo);
        Vue.set(this.rowPartida, 'dato', this.dataIndicador.datosPartidaYObjetivo.datoPartida);
        if (this.dataIndicador.datosPartidaYObjetivo.hasOwnProperty('fechaDatoObjetivo') && this.dataIndicador.datosPartidaYObjetivo.fechaDatoObjetivo !== undefined) {
          Vue.set(this.rowObjetivo, 'fecha', moment(new Date(this.dataIndicador.datosPartidaYObjetivo.fechaDatoObjetivo)).format('YYYY/MM/DD'));
        }
        if (this.dataIndicador.datosPartidaYObjetivo.hasOwnProperty('fechaDatoPartida') && this.dataIndicador.datosPartidaYObjetivo.fechaDatoPartida !== undefined) {
          Vue.set(this.rowPartida, 'fecha', moment(new Date(this.dataIndicador.datosPartidaYObjetivo.fechaDatoPartida)).format('YYYY/MM/DD'));
          Vue.set(this.rowObjetivo, 'fechaMinima', moment(new Date(this.dataIndicador.datosPartidaYObjetivo.fechaDatoPartida)).format('YYYY/MM/DD'));
        }
      }
    },
    formatDatosIntermedios () {
      this.dataIndicador.datosIntermedios.forEach(element => {
        let dateSimple = element.date.split('T');
        let obj = {
          value: element.value,
          date: moment(new Date(dateSimple[0])).format('YYYY/MM/DD')
        };
        this.datosIntermedios.push(obj);
      });
    },
    fillDatosPartida (datosPartida) {
      this.datoPartida = datosPartida.dato;
      this.fechaDatoPartida = moment(new Date(datosPartida.fecha)).format('YYYY-MM-DD');
      this.rowObjetivo.fechaMinima = moment(new Date(datosPartida.fecha)).format('YYYY-MM-DD');
      this.saveDatosObjetivooPartida();
    },
    fillDatosObjetivo (datosObjetivo) {
      this.datoObjetivo = datosObjetivo.dato;
      this.fechaDatoObjetivo = moment(new Date(datosObjetivo.fecha)).format('YYYY-MM-DD');
      this.saveDatosObjetivooPartida();
    },
    async saveDatosObjetivooPartida () {
      let arrayDatosIntermedios = [];
      this.datosIntermedios.forEach(element => {
        let objectFromated = {
          value: element.value,
          date: moment(new Date(element.date)).format('YYYY-MM-DD')
        };
        arrayDatosIntermedios.push(objectFromated);
      });
      await this.$store.dispatch(types.ACTION_SAVE_DATOS_INTERMEDIOS, {
        idCiudad: this.ciudadSelected.id,
        idCiudadIndicadorAUE: this.idCiudadIndicadorAUE,
        datosIntermedios: arrayDatosIntermedios,
        datosPartidaObjetivo: {
          datoPartida: this.datoPartida || null,
          datoObjetivo: this.datoObjetivo || null,
          fechaDatoObjetivo: this.fechaDatoObjetivo || null,
          fechaDatoPartida: this.fechaDatoPartida || null
        }
      }).then(response => {
        // lanzar evento para actualizar gráfica con datos intermedios
        this.$eventHub.$emit('updateIndicadorAUE', response.data.id);
      }).catch(() => {
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.marginTag.q-card {
  margin-top: 25px;
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  .titleCard {
    margin: 0 0px 10px 4px;
    font-size: 20px;
    font-family: DINPro;
    font-weight: bold;
    letter-spacing: 0.29px;
    color: #474848;
  }
}
.divInputTable {
  padding-right: 15px;
}
.divLabel{
  font-family: DINPro;
  font-size: 16px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.27px;
  color: #4c4c4c;
  margin-bottom:5px;
}
.divDatos {
  margin-left: 15px;
  margin-top: 25px;
}
.row {
  margin-top: 15px;
}
</style>
